(() => {
  'use strict';
  const config = document.currentScript;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-eo-country-select]');
    if (select?.form) select.form.requestSubmit();
  });
  if (!config?.hasAttribute('data-homepage')) return;

  let galleryReady = false;
  let galleryPending;
  const loadAsset = (url, style) => new Promise((resolve, reject) => {
    const element = document.createElement(style ? 'link' : 'script');
    if (style) {
      element.rel = 'stylesheet';
      element.href = url;
    } else {
      element.src = url;
      element.async = true;
    }
    element.onload = resolve;
    element.onerror = () => { element.remove(); reject(new Error('Asset unavailable')); };
    document.head.append(element);
  });
  const loadGallery = () => {
    if (!galleryPending) {
      galleryPending = loadAsset(config.dataset.galleryCss, true)
        .then(() => loadAsset(config.dataset.galleryJs, false))
        .then(() => { galleryReady = true; })
        .catch(error => { galleryPending = null; throw error; });
    }
    return galleryPending;
  };
  const warmGallery = event => {
    if (event.target.closest('.grid-product')) loadGallery().catch(() => {});
  };
  const modalReady = button => new Promise((resolve, reject) => {
    if (!button.classList.contains('quick-product__btn--not-ready')) { resolve(); return; }
    const observer = new MutationObserver(() => {
      if (!button.classList.contains('quick-product__btn--not-ready')) {
        observer.disconnect(); clearTimeout(timeout); resolve();
      }
    });
    const timeout = setTimeout(() => { observer.disconnect(); reject(new Error('Quick view unavailable')); }, 10000);
    observer.observe(button, { attributes: true, attributeFilter: ['class'] });
  });
  document.addEventListener('pointerover', warmGallery, { passive: true });
  document.addEventListener('focusin', warmGallery);
  document.addEventListener('click', event => {
    const button = event.target.closest('.quick-product__btn');
    if (!button || (galleryReady && !button.classList.contains('quick-product__btn--not-ready')) || event.button !== 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.hasAttribute('aria-busy')) return;
    button.setAttribute('aria-busy', 'true');
    Promise.all([loadGallery(), modalReady(button)]).then(() => {
      button.removeAttribute('aria-busy');
      if (button.isConnected) button.click();
    }).catch(() => {
      button.removeAttribute('aria-busy');
      const productLink = button.closest('.grid-product')?.querySelector('a.grid-product__link');
      if (productLink) window.location.assign(productLink.href);
    });
  }, true);
  document.addEventListener('quickview:open', () => loadGallery().catch(() => {}));

  class DeferredReviews extends HTMLElement {
    connectedCallback() {
      if (this.mounted || this.observer) return;
      if (!('IntersectionObserver' in window)) { this.mount(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.mount();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.retry);
    }
    mount() {
      if (this.mounted) return;
      const template = this.querySelector('template[data-eo-review-content]');
      if (!template) return;
      this.mounted = true;
      this.observer?.disconnect();
      this.querySelector('noscript')?.remove();
      template.replaceWith(template.content.cloneNode(true));
      this.dataset.eoReviewsMounted = 'true';
      let attempts = 0;
      const initialize = () => {
        if (!this.isConnected) return;
        const carousel = this.querySelector('.jdgm-carousel');
        if (!carousel || carousel.classList.contains('jdgm-carousel--done')) return;
        if (typeof window.jdgm?.initializeCarousel === 'function') {
          window.jdgm.initializeCarousel();
        } else if (++attempts < 80) {
          this.retry = setTimeout(initialize, 250);
        } else {
          this.dataset.eoReviewFallback = 'true';
        }
      };
      initialize();
    }
  }
  if (!customElements.get('eo-deferred-reviews')) customElements.define('eo-deferred-reviews', DeferredReviews);

})();
